<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <breadcrumb :breadcrumbConfig="breadcrumbConfig"></breadcrumb>
    <!--    <breadcrumb></breadcrumb>-->
    <!-- 面包屑导航 -->
    <div class="content">
      <h2>售后订单</h2>
      <h3>数据筛选</h3>
      <form-filed
        class="search-form"
        :formconfig="searchFormConfig.formconfig"
        :formData="searchFormConfig.formData"
        @cascaderValue="handlerCascaderValue"
        @formDataval="dialogClick"
        ref="formAttr"
      ></form-filed>
    </div>
    <div class="content">
      <div style="display: flex; justify-content: space-between">
        <div>
          <h3>列表数据</h3>
        </div>
        <div>
          <el-button type="primary" @click="settingAddress"
            >退货地址设置</el-button
          >
        </div>
      </div>
      <orders-list-table
        v-loading="loading"
        :dataList="page.list"
        :heightStr="columns.height"
        :config="columns.config"
        :typeStr="columns.type"
        @applyDialog="applyDialog"
        @lookDialog="lookDialog"
        @optionDialog="optionDialog"
        @tableSelectionChange="tableSelectionChange"
      ></orders-list-table>
      <!-- 分页start -->
      <div class="page" style="padding: 10px 10px; float: right">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page.currentPage"
          :page-sizes="[3, 5, 10, 20, 50]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalNum"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="退货地址"
      :visible.sync="dialogTableVisible"
      append-to-body
    >
      <div style="margin-bottom: 10px">退货地址管理</div>
      <el-table :data="gridData" border>
        <el-table-column property="name" label="收货人姓名">
          <template slot-scope="scope">
            <el-input v-model="scope.row.name" placeholder="请输入收货人姓名">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column property="phone" label="收货人电话" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.phone" placeholder="请输入收货人电话">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column property="address" label="收货地址">
          <template slot-scope="scope">
            <el-input v-model="scope.row.address" placeholder="请输入收货地址">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column property="address" label="操作" width="80px">
          <template slot-scope="scope">
            <span style="color: red" @click="deleteAddress(scope.$index)"
              >删除</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px; text-align: center">
        <el-button type="primary" @click="add">添加</el-button>
        <el-button type="primary" @click="save()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="售后申请" :visible.sync="isApplyDialog" append-to-body>
      <div style="margin-bottom: 10px">是否审核通过</div>
      <div style="margin-bottom: 10px">
        <el-radio v-model="radio" label="1">通过</el-radio>
        <el-radio v-model="radio" label="2">驳回</el-radio>
      </div>
      <div style="display: flex; margin-top: 10px" v-if="radio == 2">
        <div>备注</div>
        <div style="width: 90%; margin-left: 10px">
          <el-input
            type="textarea"
            maxlength="200"
            :rows="3"
            show-word-limit
            style="width: 100%"
            v-model="remark"
          >
          </el-input>
        </div>
      </div>
      <div style="margin-bottom: 10px" v-if="radio == 1">选择退货地址</div>
      <el-table :data="gridData" border @row-click="rowClick" v-if="radio == 1">
        <el-table-column prop="select" width="50">
          <template slot-scope="scope">
            <el-radio v-model="radioIdSelect" :label="scope.row.id"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column prop="name" label="收货人姓名" width="200">
        </el-table-column>
        <el-table-column prop="phone" label="收货人电话" width="200">
        </el-table-column>
        <el-table-column prop="address" label="收货地址"> </el-table-column>
      </el-table>
      <div style="margin-top: 20px; text-align: center">
        <el-button @click="isApplyDialog = false">取消</el-button>
        <el-button type="primary" @click="saveApply()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      append-to-body
      width="40%"
    >
      <div style="margin-bottom: 10px">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          label-width="80px"
          :rules="rules"
        >
          <el-form-item label="物流公司" prop="logisticsCompany">
            <el-select
              style="width: 100%"
              v-model="dialogForm.logisticsCompany"
              placeholder="请选择物流公司"
              filterable
            >
              <el-option
                v-for="(item, index) in dictionaries.courier_company"
                :key="index"
                :label="item.dictName"
                :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" prop="logisticsNumber">
            <el-input
              v-model="dialogForm.logisticsNumber"
              placeholder="请输入物流单号"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div style="margin-top: 20px; text-align: center">
        <el-button
          @click="dialogVisible = false"
          plain
          style="margin-right: 20px"
          >取消</el-button
        >
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="物流信息"
      :visible.sync="dialogLook"
      append-to-body
      width="40%"
    >
      <StepLogistics :stepProgress="logisticsMessage"></StepLogistics>

      <div style="margin-top: 20px; text-align: center">
        <el-button @click="dialogLook = false" plain style="margin-right: 20px"
          >取消</el-button
        >
        <el-button type="primary" @click="dialogLook = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import formFiled from '@/components/form/index'
import breadcrumb from '@/components/breadcrumb'
import LbTable from '@/components/lb-table/lb-table'
import CloseOrder from './components/CloseOrder'
import StepProgress from '@/components/StepProgress'
import modifyOrderNo from './components/modifyOrderNo'
import StepLogistics from './components/StepLogistics.vue'

import mixinsCommon from './mixins/common.js'
import OrdersListTable from './components/OrdersListTable'
// import M from 'minimatch'
import { before } from 'xe-utils/methods'

export default {
  mixins: [mixinsCommon],
  components: {
    formFiled,
    breadcrumb,
    LbTable,
    CloseOrder,
    StepProgress,
    modifyOrderNo,
    OrdersListTable,
    StepLogistics
  },
  data () {
    return {
      radio: '1',
      remark: '',
      radioIdSelect: '',
      isApplyDialog: false,
      gridData: [],
      dialogTableVisible: false,
      dialogIn: false,
      dialogRecord: false,
      dialogLook: false,
      dialogForm: {
        logisticsCompany: '',
        logisticsNumber: '',
      },
      logisticsMessage: {},
      rules: {

        logisticsCompany: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        logisticsNumber: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
        ],
      },
      dialogVisible: false,
      title: '发货',
      formType: '',
      loadinglist: false,
      btnLoading: false, // 导出物流数据加载
      titleName: '', //
      loading: false,
      sessionDictionaries: {}, // 缓存字典
      wuliuStatus: {
        resource: '',
        remark: ''
      },
      wuliuAbnormalId: '',
      currentPage1: 1,
      pageTotalNum: '', // 待备货商品的数量
      commWarehouseList: '', // 仓库数据
      importLogisticsList: [], // 导入物流单号失败的数据
      file: '', // 文件上传
      setCloseOrder: '', // 关闭原因选择值
      dialoglogistics: { visible: false, title: '编辑', type: '', row: {}, batch: false }, // 导入物流单号
      deriveRecordList: [], // 导出记录列表数据
      currentStatus: '',
      logisticsStatus: {
        all: { title: '全部', values: '', total: 0 }, // 全部
        waitPay: { title: '待付款', values: 1, total: 0 },
        waitStock: { title: '待备货', values: 2, total: 0 },
        yStock: { title: '已备货', values: 3, total: 0 },
        waitDeliverGoods: { title: '待发货', values: 4, total: 0 },
        yDeliverGoods: { title: '已发货', values: 5, total: 0 },
        takeGoods: { title: '已收货', values: 6, total: 0 },
        qGoods: { title: '已取消', values: 7, total: 0 }
      },
      statusCount: { // 物流订单分页数量统计
        total: 100, // 全部数量
        preArrangeCount: 12, // 待备货数量
        arrangedCount: 12, // 已备货数量
        prePostCount: 12, // 待发货数量
        postedCount: 13, // 已发货数量
        afterSaleCount: 14 // 售后数量
      },
      multipleSelection: [],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      breadcrumbConfig: {
        list: [
          {
            title: '订单管理',
            type: '#ff0000',
            path: '/'
          },
          {
            title: '售后订单',
            type: '1',
            path: '/platformAfterOrderList'
          }
        ]
      },

      itemListSplice: [],
      itemListAll: [],
      orgCodevalue: '',
      searchFormVal: {},
      searchFormConfig: {
        formconfig: {
          labeWidth: 100, // 表单宽度
          itemList: [// 表单的list
            { type: 'input', prop: 'orderNo', placeholder: '请输入订单编号', label: '订单编号', size: 'small' },
            { type: 'input', prop: 'goodsName', placeholder: '请输入商品名称', label: '商品名称', size: 'small' },
            { type: 'input', prop: 'postUserInfo', placeholder: '请输入收货人信息', label: '收货人信息', size: 'small' },
            {
              type: 'select',
              prop: 'platformId',
              placeholder: '请选择平台',
              label: '来源平台',
              size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'afterType', placeholder: '请选择售后类型', label: '售后类型', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            { type: 'input', prop: 'afterNo', placeholder: '请输入售后编号', label: '售后编号', size: 'small' },
            { type: 'input', prop: 'userInfo', placeholder: '请输入下单人信息', label: '下单人信息', size: 'small' },
            {
              type: 'select', prop: 'orderType', placeholder: '请选择订单类型', label: '订单类型', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'afterStatus', placeholder: '请选择售后状态', label: '售后状态', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            { type: 'daterange', prop: 'orderTime', placeholder: '请选择日期', label: '下单时间', size: 'small' },
            { type: 'daterange', prop: 'auditTime', placeholder: '请选择日期', label: '审核时间', size: 'small' },
            { type: 'daterange', prop: 'approveTime', placeholder: '请选择日期', label: '提交时间', size: 'small' }
          ],
          btnarry: [// 表单按钮
            { name: '查询', click: 'add', type: 'primary', plain: false, size: 'small' },
            { name: '重置', click: 'clrear', type: 'primary', plain: true, size: 'small' }
          ]
        },
        formData: { // 表单提交数据，
          orderGenerateType: '',
          checkbox: []// 注：如果类型是checkbox，必须foemData里边提前声明数组
        }
      },
      orgCodevalue: '',
      columnsDeriveRecord: [
        { label: '文件名', prop: 'fileName', minWidth: '230' },
        { label: '操作人', prop: 'userName', minWidth: '100' },
        { label: '导出时间', prop: 'createdDate', minWidth: '200' },
        {
          label: '操作', width: '100',
          render: (h, scope) => {
            return (
              <div>
                <el-link type='primary' size='mini' onClick={() => {
                  this.downloadlink(scope.row.excelUrl)
                }}>下载
                </el-link>
              </div>
            )
          }
        }
      ],
      columns: {
        type: 'afterOrder',
        height: '5000px',
        sortObj: {},
        config: [
          { type: 'selection', width: 50 },
          { prop: 'afterNo', label: '售后编号', width: 100, slot: 'afterNo', },
          { prop: 'info', label: '商品信息', slot: 'info', width: 280 },
          { prop: 'userName', label: '下单用户', slot: 'userName', width: 120 },
          { prop: 'postName', label: '收货人', slot: 'postName', width: 120 },
          { prop: 'address', label: '收货地址', slot: 'address', width: 150 },
          { prop: 'refundMoney', label: '金额', slot: 'price', width: 100 },
          { prop: 'orderTypeLabel', label: '订单类型', slot: 'orderTypeLabel', width: 100 },
          { prop: 'platformLabel', label: '来源平台', width: 100 },
          { prop: 'afterTypeLabel', label: '售后类型', width: 100 },
          { prop: 'afterReasonLabel', label: '售后原因', },
          { prop: 'status', label: '售后状态', slot: 'status', width: 120 },
          { prop: 'approveRemark', label: '备注' },
          { prop: 'operation', label: '操作', slot: 'operation', width: 100 },
        ]
      },
      dictionaries: {},
      orderId: '',
      file: '',
      inTitle: '导入物流单',
      addressInfo: {
        name: '',
        phone: '',
        address: ''
      },
      orderIdAfter: ''
    }
  },
  watch: {


  },
  created () {
    this.initSearchList() // 初始化，搜索需要的列表数据
    this.goodsPlatforms()
    this.getDictionaries('platform_order_type')
    this.getDictionaries('platform_order_after_type')
    this.getDictionaries('platform_order_after_status')
    this.getDictionaries('courier_company')
    this.fetchData()
  },
  mounted () {

  },
  methods: {
    //操作
    optionDialog (val) {
      console.log(val)
      if (val.type == 'delivery') {
        this.title = '寄出换货'
        this.dialogVisible = true
        this.orderId = val.val.id
      } else if (val.type == 'hedit') {
        this.title = '修改换货单号'
        this.dialogVisible = true
        this.orderId = val.val.id
        this.dialogForm.logisticsNumber = val.val.logisticsNumber
        this.dialogForm.logisticsCompany = val.val.logisticsCompany
      } else if (val.type == 'fedit') {
        this.title = '填写退货单号'
        this.dialogVisible = true
        this.orderId = val.val.id
        this.dialogForm.logisticsNumber = val.val.logisticsNumber
        this.dialogForm.logisticsCompany = val.val.logisticsCompany
      } else {
        this.title = '修改退货单号'
        this.dialogVisible = true
        this.orderId = val.val.id
        this.dialogForm.logisticsNumber = val.val.logisticsNumber
        this.dialogForm.logisticsCompany = val.val.logisticsCompany
      }

    },
    saveApply () {
      let data = {
        status: Number(this.radio),
        id: this.orderIdAfter,
        remark: this.remark,
        name: this.addressInfo.name,
        phone: this.addressInfo.phone,
        address: this.addressInfo.address
      }
      this.$api.saveAfterAudit(data).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.isApplyDialog = false
          this.fetchData()
        }
      })
    },
    rowClick (row) {
      this.radioIdSelect = row.id
      this.addressInfo.name = row.name
      this.addressInfo.phone = row.phone
      this.addressInfo.address = row.address
    },

    save () {
      this.$api.saveAfterAddressList(this.gridData).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '保存成功'
          });
          this.dialogTableVisible = false
          this.fetchData()
        }
      })
    },
    deleteAddress (index) {
      this.$confirm('删除后不可恢复数据，是否继续？?', '提示信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warnning'
      }).then(() => {
        this.gridData.splice(index, 1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    add () {
      let obj = {
        name: '',
        phone: '',
        address: ''
      }
      this.gridData.push(obj)
    },
    settingAddress () {
      this.dialogTableVisible = true
      this.$api.afterAddressList({}).then(res => {
        if (res.code == 0) {
          this.gridData = res.data
        }
      })
    },
    submitIn () {
      const formData = new FormData()
      formData.append('file', this.file)
      if (this.inTitle == '导入物流单') {
        formData.append('updateSupport', 0)
      } else {
        formData.append('updateSupport', 1)
      }
      console.log(formData)
      this.$api.inlogisticsOrder(formData).then(res => {
        if (res.code == 0) {
          this.$message.success('导入成功！')
        }
      })
    },
    // 导入物流单
    orderImport (fileObj) {
      this.file = fileObj.file
    },
    leadingIn (val) {
      this.dialogIn = true
      if (val == 0) {
        this.inTitle = '导入物流单'
      } else {
        this.inTitle = '批量修改物流单'
      }

    },
    importLogisticsData (val) {
      this.$refs.formAttr.submitForm('ruleForm')
      console.log(this.searchFormVal)
      const ids = []
      if (this.multipleSelection.length != 0) {
        this.multipleSelection.forEach((item) => {
          ids.push(item.id)
        })
      }
      let data = {
        status: val,
        pageNo: this.page.currentPage,
        pageSize: this.page.pageSize,
      }
      const searchForm = this.searchFormVal
      data = Object.assign(data, searchForm)
      if (data.postTime) {
        data.postTime = data.postTime
        data.postTimeStart = data.postTime[0]
        data.postTimeEnd = data.postTime[1]
      }
      this.$api.exportlogisticsData(data).then((res) => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.btnLoading = false
          // this.downloadlink(res.data)
          this.$message.success('操作成功！')
          this.fetchData('search')
        } else {
          this.btnLoading = false
        }
      }).catch((err) => {
        console.log(err)
        this.btnLoading = false
      })
    },
    // 导出
    importLogisticsOrder () {
      this.$refs.formAttr.submitForm('ruleForm')
      console.log(this.searchFormVal)
      const ids = []
      if (this.multipleSelection.length != 0) {
        this.multipleSelection.forEach((item) => {
          ids.push(item.id)
        })
      }
      let data = {

      }
      const searchForm = this.searchFormVal
      data = Object.assign(data, searchForm)
      if (data.postTime) {
        data.postTimeStart = data.postTime[0]
        data.postTimeEnd = data.postTime[1]
      }
      if (data.createdTime) {
        data.createdTimeStart = data.createdTime[0]
        data.createdTimeEnd = data.createdTime[1]
      }
      this.$api.exportlogisticsOrder(data).then((res) => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.btnLoading = false
          // this.downloadlink(res.data)
          this.$message.success('操作成功！')
          this.fetchData('search')
        } else {
          this.btnLoading = false
        }
      }).catch((err) => {
        console.log(err)
        this.btnLoading = false
      })
    },
    // 导出记录列表查询
    onApplierExport () {
      this.dialogRecord = true

      const params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
      }
      this.$api.exportRecord(params).then((res) => {
        if (res.code == 0) {
          this.deriveRecordList = res.data
        }
        // this.downloadlink(res.data)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 每页条数
    handleSizeChangeDeriveRecord (val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.onApplierExport()
    },
    // 当前页
    handleCurrentChangeDeriveRecord (val) {
      this.page.pageNo = val
      this.onApplierExport()
    },
    tableSelectionChange (val) {
      console.log(val)
      this.multipleSelection = val
    },
    //导出发货
    deriveDeliverGoods () {
      let params = {}
      let arr = []
      this.multipleSelection.forEach(item => {
        arr.ids.push(item.id)
      })
      const searchForm = this.searchFormVal
      params = Object.assign(params, searchForm)
      params.orderIdList = arr
      this.$api.exportDelivery(params).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink (url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    // 备货
    onStockUp (batch, obj) {
      // true 批量
      const params = { ids: [] }
      if (batch) {
        const multipleSelection = this.multipleSelection
        if (multipleSelection.length === 0) {
          return this.$message.warning('请选择数据！')
        } else {
          multipleSelection.forEach(item => {
            params.ids.push(item.id)
          })
        }
      } else {
        params.ids.push(obj.id)
      }
      this.$confirm('是否备货已选中的订单?', '备货', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.logisticsStock(params).then((res) => {
          if (res.code === 0) {
            this.fetchData()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          } else {
            console.log('失败')
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    onChangeLogisticsStatus (val) {
      this.currentStatus = val
      this.searchFormVal.orderStatus = val
      this.fetchData()
    },
    // 物流信息
    getlogistics (id, type) {
      const params = {
        id: id,
        logisticsType: type
      }
      this.$api.getLogisticsAfterDetail(params).then(res => {
        if (res.code == 0) {
          if (this.dictionaries.order_status_logistics.length !== 0 && res.data.status) {
            res.data.statusCn = this.dictionaries.order_status_logistics.find(e => { return e.dictId === res.data.status }).dictName
          }
          if (this.dictionaries.courier_company.length !== 0 && res.data.logisticsCompany) {
            res.data.logisticsCompanyCN = this.dictionaries.courier_company.find(e => { return e.dictId === res.data.logisticsCompany }).dictName
          }
          // console.log(logisticsCompany)
          this.logisticsMessage = res.data
          // this.logisticsMessage.logisticsCompany = logisticsCompany
        }
      })
    },
    submit () {
      this.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          if (this.title == '填写退货单号') {
            let data = {
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.$api.addLogistics(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.fetchData()
              }

            })
          } else if (this.title == '寄出换货') {
            let data = {
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.$api.afterH(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.fetchData()
              }

            })
          } else {
            let type = 0
            if (this.title == '修改退货单号') {
              type = 1
            } else {
              type = 2
            }
            let data = {
              logisticsType: type,
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.$api.updateLogisticsNo(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.fetchData()
              }

            })
          }
        } else {
          return false;
        }
      });

    },
    lookDialog (val) {
      this.dialogLook = true
      console.log(val)
      this.getlogistics(val.val.id, val.type)
    },
    //审核
    applyDialog (val) {
      this.orderIdAfter = val.id
      this.isApplyDialog = true
      this.remark = ''
      this.$api.afterAddressList({}).then(res => {
        if (res.code == 0) {
          this.gridData = res.data
        }
      })
    },
    // 获取字典数据
    getDictionaries (type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        if (type == 'platform_order_type') {
          let list = []
          list = res.data
          const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '订单类型' })
          list.forEach(item => {
            item.label = item.dictName
            item.value = item.dictId
          })
          this.searchFormConfig.formconfig.itemList[payIndex].option = list
        }
        if (type == 'platform_order_after_status') {
          let list = []
          list = res.data
          const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '售后状态' })
          list.forEach(item => {
            item.label = item.dictName
            item.value = item.dictId
          })
          this.searchFormConfig.formconfig.itemList[payIndex].option = list
        }
        if (type == 'platform_order_after_type') {
          let list = []
          list = res.data
          const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '售后类型' })
          list.forEach(item => {
            item.label = item.dictName
            item.value = item.dictId
          })
          this.searchFormConfig.formconfig.itemList[payIndex].option = list
        }
        if (type == 'courier_company') {
          this.dictionaries.courier_company = res.data
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    goodsPlatforms () {
      const params = {
        userId: null,
        username: null,
        phone: null,
        vipLevel: null,
        categoryIds: null,
        openTimeStart: null,
        openTimeEnd: null,
        status: 1
      }
      this.$api.goodsPlatforms(params).then((res) => {
        let platformList = []
        platformList = res.data
        const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '来源平台' })
        platformList.forEach(item => {
          item.label = item.name
          item.value = item.id
        })
        this.searchFormConfig.formconfig.itemList[payIndex].option = platformList
      }).catch((err) => {
        console.log(err)
      })
    },
    // 初始化，搜索需要的列表数据
    initSearchList () {
      const params = { pageNo: 1, pageSize: 1001 }
    },
    dialogClick (val, state) {
      this.searchFormVal = val
      console.log(this.searchFormVal, 'searchFormVal')
      this.fetchData('search')
      // this.formFiledData = Object.assign(this.formFiledData, val)
      // console.log(this.formFiledData,'接受表单组件的数据');
    },
    handlerCascaderValue (value) {
      console.log(value, 'value')
      this.orgCodevalue = value
    },
    fetchData (type) {
      this.loadinglist = true
      if (type === 'reset') {
        this.$refs['searchForm'].resetFields()
        this.page.pageNo = 1
        this.page.pageSize = 10
        this.page.currentPage = 1
      }
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        status: this.page.status
      }
      const searchForm = this.searchFormVal
      params = Object.assign(params, searchForm)
      if (type === 'search' || type === 'changePage') {
        this.formType = 'search'
        if (type === 'search') {
          this.page.currentPage = 1
          this.page.pageNo = 1
          params.pageNo = 1
        }
        const searchForm = this.searchFormVal
        params.pageNo = this.page.pageNo
        params = Object.assign(params, searchForm)
        if (params.orderTime) {
          params.orderTimeStart = params.orderTime[0]
          params.orderTimeEnd = params.orderTime[1]
        }
        if (params.auditTime) {
          params.auditTimeStart = params.auditTime[0]
          params.auditTimeEnd = params.auditTime[1]
        }
        if (params.approveTime) {
          params.approveTimeStart = params.approveTime[0]
          params.approveTimeEnd = params.approveTime[1]
        }

        // if (params.orgCode) {
        //   params.orgCode = params.orgCode[params.orgCode.length - 1]
        // }
        // params.categoryId = searchForm.categoryId[searchForm.categoryId.length - 1]
        // 去除字符串 前后 空格
        for (const item in params) {
          if (typeof params[item] === 'string') {
            params[item] = params[item].trim()
          }
        }
      }

      this.$api.afterOrderPlatformList(params).then((res) => {
        if (res.code === 0) {
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
        } else {
          console.log('goodsPageList - 失败', type)
        }
        this.loadinglist = false
        // this.getStatusCount(params)// 物流订单分页数量统计查询接口
      }).catch((err) => {
        console.log(err)
        this.loadinglist = false
      })
    },
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData('changePage')
      console.log(currentChange)
    },
    handleSizeChange (sizeChange) {
      this.page.currentPage = 1
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 每页条数
    handleSizeChangeDeriveRecord (val) {
      this.page.currentPage = 1
      this.page.pageSize = val

    },
    // 当前页
    handleCurrentChangeDeriveRecord (val) {
      this.page.pageNo = val

    },
  }
}
</script>

<style scoped lang="scss">
/deep/ .hide-content {
  display: none !important;
}

/deep/ .el-button {
  border: none;
}

/deep/ .el-link {
  margin: 0 5px;
}

/deep/ .el-table th > .cell,
/deep/ .el-table td {
  text-align: unset;
}

.but-list:after {
  clear: both;
  display: table;
  content: "";
}

.but-list {
  margin-bottom: 20px;

  .left {
    float: left;

    /deep/ .el-button {
      width: 120px;
      height: 36px;
      border-radius: 4px;
      font-size: 16px;
    }
  }

  .right {
    float: right;

    /deep/ .el-button {
      min-width: 120px;
      height: 36px;
      border-radius: 4px;
      font-size: 16px;
    }

    // 批量备货
    .stay-stock-up-but {
      color: #409eff;
      border: 1px solid #409eff;
      background-color: #ffffff;
    }

    // 导出发货
    .stock-up-send-but {
    }

    // 导出记录
    .stock-up-record-but {
      background-color: #7763dd;
    }

    // 导出物流单
    .stay-deliver-goods-but {
    }

    // 批量修改物流单号
    .deliver-goods-but {
      width: 160px;
      height: 36px;
      border: 1px solid #4168e7;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 400;
      color: #4168e7;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .cancel {
    width: 120px;
    height: 36px;
    border: 1px solid #d9d9d9;
    opacity: 1;
    border-radius: 4px;
  }

  .affirm {
    width: 120px;
    height: 36px;
    background: #4168e7;
    opacity: 1;
    border-radius: 4px;
  }
}

/deep/ .el-upload-dragger {
  width: 600px !important;
}

.dialogBtnright {
  display: flex;
  justify-content: space-between;
}

.dialogBtnright_right {
  display: flex;
  justify-content: right !important;
}

.setPay_payment_btn_quxiao {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  color: rgba(153, 153, 153, 1);
  border-radius: 4px;
  line-height: 0;
}

.setPay_payment_btn_queren {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  border: 0;
}

.block {
  text-align: right;
}

.setPay_payment {
  display: block;
  margin-bottom: 15px;
}

.dialog-btn {
  text-align: right;
}

/deep/ .el-table__row td .cell span,
/deep/ .el-table__row td .cell div p {
  display: block;
  //overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
}

.wuliuAbnormal_box {
  display: flex;
  margin-bottom: 20px;
}

.radio_group {
  margin-left: 20px;
}

.radio_group_item {
  margin-bottom: 10px;
}

.wuliuAbnormal_box_title {
  margin-top: -5px;
}
/deep/.el-select {
  border-left: none;
  border-right: none;
  input {
    border-left: 1px solid #d8dce5 !important;
    border-right: 1px solid #d8dce5 !important;
    border-radius: 5px !important;
  }
}
/deep/.el-scrollbar {
  height: 10px;
}
/deep/.el-scrollbar__bar.is-horizontal {
  height: 9px;
}
</style>
